import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, combineReducers, applyMiddleware } from 'redux';
import {Provider} from 'react-redux';
import createBrowserHistory from 'history/createBrowserHistory';
import RouteMap from '../router/reading/routeMap';
import { ConnectedRouter, routerReducer, routerMiddleware} from 'react-router-redux';
import registerServiceWorker from '../registerServiceWorker';
import { composeWithDevTools } from 'redux-devtools-extension';
import Thunk from 'redux-thunk';
import reducers from 'srcRedux/reducers/reading/index';

const composeEnhancers = composeWithDevTools({
	// Specify name here, actionsBlacklist, actionsCreators and other options if needed
});

const history = createBrowserHistory();
const middleware = routerMiddleware(history);
let initState = {};


const store = createStore(
	combineReducers(Object.assign({},reducers,{
		router: routerReducer
	})),
	initState,
	composeEnhancers(applyMiddleware(Thunk,middleware))
);

ReactDOM.render(
	<Provider store={store}>
		<ConnectedRouter history={history}>
			<RouteMap history={history} />
		</ConnectedRouter>
	</Provider>,
	document.getElementById('scale-wrapper')
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index/reading.js